export default "__VITE_ASSET__BaH4NxVX__"